import './App.css';
import { ThemeProvider } from './shared/theme/ThemeContext';
import { I18nProvider } from './shared/i18n/I18nContext';
import { AuthProvider } from './features/auth/logic/authProvider';
import AppRouter from './shared/routing/AppRouter';

function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </I18nProvider>
    </ThemeProvider>
  );
}

export default App;
